import React, { useState } from "react";

const UpgradePage = () => {
  const [loading, setLoading] = useState(false);
  const [validatieResult, setValidatieResult] = useState(null);
  const [migratieResult, setMigratieResult] = useState(null);
  const [error, setError] = useState(null);
  const [dryRunResult, setDryRunResult] = useState(null);

  const handleResponse = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      return response.json().then(err => {
        throw new Error(err.message || response.statusText);
      });
    }
  };

  // Validatie: Bekijk huidige status
  const handleValidatie = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        "/api/admin/gastenverbruik/migratie/devicearray/validatie",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token")
          }
        }
      );
      const data = await handleResponse(response);
      setValidatieResult(data.resultaat);
    } catch (err) {
      setError(err.message || "Er is een fout opgetreden bij validatie");
      console.error("Validatie fout:", err);
    } finally {
      setLoading(false);
    }
  };

  // Dry Run: Simulatie zonder wijzigingen
  const handleDryRun = async () => {
    setLoading(true);
    setError(null);
    setDryRunResult(null);
    try {
      const response = await fetch(
        "/api/admin/gastenverbruik/migratie/devicearray?dryRun=true",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token")
          }
        }
      );
      const data = await handleResponse(response);
      setDryRunResult(data.resultaat);
    } catch (err) {
      setError(err.message || "Er is een fout opgetreden bij dry run");
      console.error("Dry run fout:", err);
    } finally {
      setLoading(false);
    }
  };

  // Echte Migratie: Wijzigt data!
  const handleMigratie = async () => {
    if (!window.confirm(
      "⚠️ WAARSCHUWING: Deze actie zal data wijzigen in de database!\n\n" +
      "Zorg ervoor dat je:\n" +
      "- Een database backup hebt gemaakt\n" +
      "- De validatie hebt uitgevoerd\n" +
      "- De dry run succesvol was\n\n" +
      "Weet je zeker dat je wilt doorgaan?"
    )) {
      return;
    }

    setLoading(true);
    setError(null);
    setMigratieResult(null);
    try {
      const response = await fetch(
        "/api/admin/gastenverbruik/migratie/devicearray?dryRun=false",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token")
          }
        }
      );
      const data = await handleResponse(response);
      setMigratieResult(data.resultaat);
      // Refresh validatie na migratie
      setTimeout(() => {
        handleValidatie();
      }, 1000);
    } catch (err) {
      setError(err.message || "Er is een fout opgetreden bij migratie");
      console.error("Migratie fout:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title">Database Upgrade - Multi-Sensor Migratie</h3>
            </div>
            <div className="box-body">
              <div className="alert alert-info">
                <h4>
                  <i className="fa fa-info-circle"></i> Over deze upgrade
                </h4>
                <p>
                  Deze upgrade migreert de database van het oude single-sensor systeem naar het nieuwe multi-sensor systeem.
                  Hierbij kunnen plaatsen meerdere sensoren hebben.
                </p>
                <p className="mb-0">
                  <strong>Volg deze stappen:</strong>
                </p>
                <ol>
                  <li>Validatie: Bekijk huidige status</li>
                  <li>Dry Run: Test de migratie zonder wijzigingen</li>
                  <li>Echte Migratie: Voer de migratie uit (wijzigt data!)</li>
                </ol>
              </div>

              {error && (
                <div className="alert alert-danger">
                  <h4>
                    <i className="fa fa-exclamation-triangle"></i> Fout
                  </h4>
                  <p>{error}</p>
                </div>
              )}

              {/* Actie Knoppen */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <h4>Migratie Acties</h4>
                  <div className="btn-group" role="group">
                    <button
                      className="btn btn-info"
                      onClick={handleValidatie}
                      disabled={loading}
                    >
                      <i className="fa fa-search"></i> Stap 1: Validatie
                    </button>
                    <button
                      className="btn btn-warning"
                      onClick={handleDryRun}
                      disabled={loading || !validatieResult}
                    >
                      <i className="fa fa-flask"></i> Stap 2: Dry Run
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={handleMigratie}
                      disabled={loading || !dryRunResult}
                    >
                      <i className="fa fa-rocket"></i> Stap 3: Uitvoeren
                    </button>
                  </div>
                  {loading && (
                    <span className="ml-3">
                      <i className="fa fa-spinner fa-spin"></i> Bezig...
                    </span>
                  )}
                </div>
              </div>

              {/* Validatie Resultaten */}
              {validatieResult && (
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="alert alert-success">
                      <h4>
                        <i className="fa fa-check-circle"></i> Validatie Resultaten
                      </h4>

                      <div className="row">
                        <div className="col-md-6">
                          <h5>Plaatsen Status</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr>
                                <td>Totaal (plaatsen + accommodaties)</td>
                                <td><strong>{validatieResult.plaatsen.totaal}</strong></td>
                              </tr>
                              <tr className="table-success">
                                <td>Al gemigreerd (array formaat)</td>
                                <td><strong>{validatieResult.plaatsen.array}</strong></td>
                              </tr>
                              <tr className={validatieResult.plaatsen.objectId > 0 ? "table-warning" : ""}>
                                <td>Te migreren (single sensor)</td>
                                <td><strong>{validatieResult.plaatsen.objectId}</strong></td>
                              </tr>
                              <tr>
                                <td>Geen device/meters</td>
                                <td>{validatieResult.plaatsen.geenDevice}</td>
                              </tr>
                            </tbody>
                          </table>
                          <small className="text-muted">
                            * Accommodaties hebben al meters array en tellen als gemigreerd
                          </small>
                        </div>

                        <div className="col-md-6">
                          <h5>Gastenverbruik Status</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr>
                                <td>Actieve reserveringen</td>
                                <td><strong>{validatieResult.gastenverbruik.actief}</strong></td>
                              </tr>
                              <tr className={validatieResult.gastenverbruik.metSensor === validatieResult.gastenverbruik.actief ? "table-success" : "table-warning"}>
                                <td>Met sensor referentie</td>
                                <td><strong>{validatieResult.gastenverbruik.metSensor}</strong></td>
                              </tr>
                            </tbody>
                          </table>

                          {validatieResult.sensoren && (
                            <>
                              <h5 className="mt-3">Sensor Types</h5>
                              <table className="table table-sm table-bordered">
                                <tbody>
                                  <tr>
                                    <td>Totaal sensoren</td>
                                    <td><strong>{validatieResult.sensoren.totaal}</strong></td>
                                  </tr>
                                  {Object.entries(validatieResult.sensoren.types || {}).map(([type, count]) => (
                                    <tr key={type}>
                                      <td>{type}</td>
                                      <td>{count}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </>
                          )}
                        </div>
                      </div>

                      {validatieResult.plaatsen.objectId === 0 ? (
                        <div className="alert alert-success mt-3">
                          <i className="fa fa-check"></i> Alle plaatsen zijn al gemigreerd naar het nieuwe multi-sensor systeem!
                        </div>
                      ) : (
                        <div className="alert alert-warning mt-3">
                          <i className="fa fa-exclamation-triangle"></i> Er zijn nog {validatieResult.plaatsen.objectId} plaatsen die gemigreerd moeten worden.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Dry Run Resultaten */}
              {dryRunResult && (
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="alert alert-warning">
                      <h4>
                        <i className="fa fa-flask"></i> Dry Run Resultaten (Simulatie)
                      </h4>
                      <p>Deze resultaten tonen wat er zou gebeuren zonder daadwerkelijk data te wijzigen.</p>

                      <div className="row">
                        <div className="col-md-4">
                          <h5>Kampeerplaatsen</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr>
                                <td>Geconverteerd</td>
                                <td><strong>{dryRunResult.kampeerplaatsenResult?.gemigreerd || 0}</strong></td>
                              </tr>
                              <tr>
                                <td>Al array</td>
                                <td>{dryRunResult.kampeerplaatsenResult?.alArray || 0}</td>
                              </tr>
                              <tr>
                                <td>Totaal naar plaatsen</td>
                                <td><strong>{dryRunResult.kampeerplaatsenResult?.totaal || 0}</strong></td>
                              </tr>
                              <tr className={dryRunResult.kampeerplaatsenResult?.fouten > 0 ? "table-danger" : ""}>
                                <td>Fouten</td>
                                <td>{dryRunResult.kampeerplaatsenResult?.fouten || 0}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="col-md-4">
                          <h5>Accommodaties</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr>
                                <td>Naar plaatsen</td>
                                <td><strong>{dryRunResult.accommodatiesResult?.gemigreerd || 0}</strong></td>
                              </tr>
                              <tr className={dryRunResult.accommodatiesResult?.fouten > 0 ? "table-danger" : ""}>
                                <td>Fouten</td>
                                <td>{dryRunResult.accommodatiesResult?.fouten || 0}</td>
                              </tr>
                            </tbody>
                          </table>

                          <h5 className="mt-3">Sensor Referenties</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr>
                                <td>Geupdatet</td>
                                <td><strong>{dryRunResult.sensorRefResult?.geupdatet || 0}</strong></td>
                              </tr>
                              <tr>
                                <td>Geen sensor</td>
                                <td>{dryRunResult.sensorRefResult?.geenSensor || 0}</td>
                              </tr>
                              <tr className={dryRunResult.sensorRefResult?.fouten > 0 ? "table-danger" : ""}>
                                <td>Fouten</td>
                                <td>{dryRunResult.sensorRefResult?.fouten || 0}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {((dryRunResult.kampeerplaatsenResult?.fouten || 0) > 0 ||
                        (dryRunResult.accommodatiesResult?.fouten || 0) > 0 ||
                        (dryRunResult.sensorRefResult?.fouten || 0) > 0) ? (
                        <div className="alert alert-danger mt-3">
                          <i className="fa fa-exclamation-triangle"></i> Er zijn fouten gevonden! Check de server logs voor details voordat je de echte migratie uitvoert.
                        </div>
                      ) : (
                        <div className="alert alert-success mt-3">
                          <i className="fa fa-check"></i> Dry run succesvol! Je kunt nu de echte migratie uitvoeren.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Migratie Resultaten */}
              {migratieResult && (
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="alert alert-success">
                      <h4>
                        <i className="fa fa-check-circle"></i> Migratie Voltooid!
                      </h4>

                      <div className="row">
                        <div className="col-md-4">
                          <h5>Kampeerplaatsen</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr className="table-success">
                                <td>Geconverteerd</td>
                                <td><strong>{migratieResult.kampeerplaatsenResult?.gemigreerd || 0}</strong></td>
                              </tr>
                              <tr>
                                <td>Al array</td>
                                <td>{migratieResult.kampeerplaatsenResult?.alArray || 0}</td>
                              </tr>
                              <tr className="table-success">
                                <td>Totaal naar plaatsen</td>
                                <td><strong>{migratieResult.kampeerplaatsenResult?.totaal || 0}</strong></td>
                              </tr>
                              <tr className={migratieResult.kampeerplaatsenResult?.fouten > 0 ? "table-danger" : "table-success"}>
                                <td>Fouten</td>
                                <td>{migratieResult.kampeerplaatsenResult?.fouten || 0}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="col-md-4">
                          <h5>Accommodaties</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr className="table-success">
                                <td>Naar plaatsen</td>
                                <td><strong>{migratieResult.accommodatiesResult?.gemigreerd || 0}</strong></td>
                              </tr>
                              <tr className={migratieResult.accommodatiesResult?.fouten > 0 ? "table-danger" : "table-success"}>
                                <td>Fouten</td>
                                <td>{migratieResult.accommodatiesResult?.fouten || 0}</td>
                              </tr>
                            </tbody>
                          </table>

                          <h5 className="mt-3">Sensor Referenties</h5>
                          <table className="table table-sm table-bordered">
                            <tbody>
                              <tr className="table-success">
                                <td>Geupdatet</td>
                                <td><strong>{migratieResult.sensorRefResult?.geupdatet || 0}</strong></td>
                              </tr>
                              <tr>
                                <td>Geen sensor</td>
                                <td>{migratieResult.sensorRefResult?.geenSensor || 0}</td>
                              </tr>
                              <tr className={migratieResult.sensorRefResult?.fouten > 0 ? "table-danger" : "table-success"}>
                                <td>Fouten</td>
                                <td>{migratieResult.sensorRefResult?.fouten || 0}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {migratieResult.postValidatie && (
                        <div className="alert alert-info mt-3">
                          <h5>Post-Migratie Status</h5>
                          <p>
                            Plaatsen met array: <strong>{migratieResult.postValidatie.plaatsen.array}</strong> van {migratieResult.postValidatie.plaatsen.totaal}
                          </p>
                          <p className="mb-0">
                            Gastenverbruik met sensor: <strong>{migratieResult.postValidatie.gastenverbruik.metSensor}</strong> van {migratieResult.postValidatie.gastenverbruik.actief}
                          </p>
                        </div>
                      )}

                      <div className="alert alert-success mt-3">
                        <i className="fa fa-check"></i> Database upgrade succesvol voltooid! Het systeem ondersteunt nu meerdere sensoren per plaats.
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Instructies */}
              <div className="row mt-4">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h4>
                        <i className="fa fa-book"></i> Instructies
                      </h4>
                    </div>
                    <div className="card-body">
                      <h5>Wat doet deze migratie?</h5>
                      <ul>
                        <li>Kopieert kampeerplaatsen van <code>kampeerplaatsens</code> naar <code>plaatsen</code> collection</li>
                        <li>Converteert single-sensor (ObjectId) naar multi-sensor array formaat</li>
                        <li>Kopieert accommodaties van <code>accommodaties</code> naar <code>plaatsen</code> collection</li>
                        <li>Converteert meters array naar device array formaat</li>
                        <li>Update actieve gastenverbruik records met directe sensor referenties</li>
                        <li>Alle plaatsen en accommodaties worden samengevoegd in één centrale "plaatsen" collection</li>
                      </ul>

                      <h5>Veiligheidsmaatregelen</h5>
                      <ul>
                        <li><strong>Maak altijd een database backup</strong> voordat je de migratie uitvoert!</li>
                        <li>Voer eerst de validatie uit om te zien hoeveel records gemigreerd moeten worden</li>
                        <li>Test met dry run voordat je de echte migratie uitvoert</li>
                        <li>Check de server console logs voor gedetailleerde informatie</li>
                      </ul>

                      <h5>Bij problemen</h5>
                      <ul>
                        <li>Check de server console logs voor foutmeldingen</li>
                        <li>Gebruik de validatie om de huidige status te controleren</li>
                        <li>Restore de database backup indien nodig</li>
                        <li>Neem contact op met de development team bij persistente problemen</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePage;
